import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './Navbar.css';
import logo from '../../assets/sentmo-logo.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { lang, t, switchLanguage, supportedLocales } = useLanguage();

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-left">
        <NavLink to={`/${lang}`}>
          <img src={logo} alt="Sentmo Logo" className="navbar-logo" />
        </NavLink>
      </div>
      <div className="navbar-center">
        <div className="navbar-links">
          <NavLink to={`/${lang}`} className="navbar-link" end>
            {t.nav.home}
          </NavLink>
          <NavLink to={`/${lang}/sentiment`} className="navbar-link">
            {t.nav.sentiment}
          </NavLink>
          <NavLink to={`/${lang}/blog`} className="navbar-link">
            {t.nav.blog}
          </NavLink>
        </div>
      </div>
      <div className="navbar-right">
        <div className="language-switcher">
          {supportedLocales.map((locale) => (
            <button
              key={locale}
              onClick={() => switchLanguage(locale)}
              className={`lang-btn ${lang === locale ? 'active' : ''}`}
              aria-label={`Switch to ${locale.toUpperCase()}`}
            >
              {locale.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
